module.exports = function() {
  return new Worker(__webpack_public_path__ + "44762d9cec21203124e0.worker.js");
};